import React, { useState } from "react";
import styled from "styled-components";
import img1 from "../assets/icons/service-icon1.svg";
import img2 from "../assets/icons/service-icon2.svg";
import Bg1 from "../assets/images/bg/matte-10_2x.png"
import Card2 from "../components/Card2/Card2";
import Card2Copy from "../components/Card2/Card2Copy";


const data = [
  {
    id: 1,
    image: img1,
    title: "Pharmacy Services",
    desc: "At Senior Consideration, consumer loyalty generally remains our need. We offer a large number of clinical supplies and frill in ostomy, wound care, diabetes, incontinence, skin health management, urological, torment treatment, pressure stockings and top notch wholesome enhancements.   ",
  },
  {
    id: 2,
    image: img2,
    title: "Pharmacy Resources",
    desc: "Senior Consideration stands prepared to serve you with every one of your requirements for clinical hardware's. We resolve to convey the most significant level of greatness in items along with administrations. We are not only a provider direct to your home, we are an organization that has some expertise in perceiving your particular necessities and finding what is best for you. ",
  },
];

const Categories = () => {
  const [modal, setModal] = useState(false);

  const toggleModal = () => {
    setModal(!modal);
  };
  const [modal2, setModal2] = useState(false);

  const toggleModal2 = () => {
    setModal2(!modal2);
  };
  return (
    <>
    <CategoryContainer>
      <BgImg src={Bg1}/>
      <CategoryContainerleft>
        <CategoryContainerleftTitle >
          Anything you need,we’ve got you covered
        </CategoryContainerleftTitle>
        <CategoryContainerleftBtn >Get in Touch</CategoryContainerleftBtn>
      </CategoryContainerleft>
      <CategoryContainerright>
        <CardContainer>
          {data.map((item) => {
            return (
              <Card key={item.id} onClick={toggleModal2}>
                <Image id="card_image" src={item.image} alt={item.title} />
                <Heading id="card_heading">{item.title}</Heading>
                <Desc>{item.desc}</Desc>
              </Card>
            );
          })}
        </CardContainer>
      </CategoryContainerright>
    </CategoryContainer>
        {modal && (
          <Card2/>
        )}
        {modal2 && (
          <Card2Copy/>
        )}
    </>
  );
};

export default Categories;

const BgImg = styled.img`
  position: absolute;
  top: 20%;
  left: 30%;
  z-index: -1;
  opacity: 0.5;
  transform: scale(2);
`;

const CardContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2rem;
  
`;

const Card = styled.div`
  display: grid;
  gap: 1rem;
  background-color: #fff;
  padding: 40px 45px;
  margin: 10px;
  -webkit-box-shadow: 0px 3px 7px 0px rgba(28, 31, 33, 0.15);
  -moz-box-shadow: 0px 3px 7px 0px rgba(28, 31, 33, 0.15);
  box-shadow: 0px 3px 7px 0px rgba(28, 31, 33, 0.15);
  min-height: 400px;
  min-width: 250px;
  margin: auto;
`;

const Image = styled.img`
  width: auto;
  justify-self: start;
`;

const Heading = styled.h3`
  color: var(--color-blue);
  letter-spacing: 2px;
  font-size: 2rem;
  line-height: 3rem;
`;

const Desc = styled.h4`
  color: var(--color-blue);
  text-align: justify;
  opacity: 0.6;
  letter-spacing: 1px;
`;

const CategoryContainerleftBtn = styled.button`
  border: none;
  font-weight: bold;
  letter-spacing: 1.5px;
  font-size: 1rem;
  color: white;
  background: var(--color-red);
  padding: 1rem 3rem;
  border-radius: 3rem;

  &:hover {
    color: var(--color-red);
    background: white;
    outline: 2px solid var(--color-red);
  }
`;

const CategoryContainerleftTitle = styled.div`
  color: var(--color-blue);
  letter-spacing: 2.5px;
  font-size: 2.5rem;
  line-height: 3rem;
  font-weight: bolder;
`;

const CategoryContainerleft = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 2rem;
`;
const CategoryContainerright = styled.div``;

const CategoryContainer = styled.div`
  display: grid;
  grid-auto-flow: column;
  padding-top: 5rem;
  padding-bottom: 5rem;
  max-width: 1200px;
  margin: auto;
  position: relative;
  z-index: 1;
`;
